module.exports = __webpack_public_path__ + "static/media/gn.d08b3d1f.svg";